import(/* webpackMode: "eager" */ "/home/runner/work/brev-app/brev-app/packages/frontend/app/error.tsx");
